<template>
<div class="container" data-aos="fade-up">
    <div class="row">
        <h2 class="text-center hk-heading my-4">{{ $t('why_choose_hk.why_choose_hk_heading') }}</h2>
        <div class="col-md-6" v-for="(card, index) in cards" :key="index">
            <div class="card">
                <div class="image-container mt-4">
                    <img :src="card.imgSrc" class="card-img-top" alt="Card image" loading="lazy">
                </div>
            </div>
            <div class="outside-text-container">
                <h5 class="hk-subheading mb-3">{{ card.title }}</h5>
                <p class="hk-subbody">{{card.outsideText}}</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import img1 from '@/assets/home/why-hotelkey-comprehensive.webp';
import img2 from '@/assets/home/why-hotelkey-built.webp';
import img3 from '@/assets/home/why-hotelkey-flexible.webp';
import img4 from '@/assets/home/why-hotelkey-24x7.webp';

export default {
    name: 'whychoosehk',
    data() {
        return {
            cards: [{
                    imgSrc: img1,
                    alt:"Comprehensive Enterprise | HotelKey",
                    title: "Full-Suite Hospitality Software Platform",
                    outsideText:this.$t("why_choose_hk.card_one_subheading"),
                },
                {
                    imgSrc: img2,
                    alt:"Efficiency | HotelKey",
                    title: this.$t("why_choose_hk.card_two_heading"),
                    outsideText:this.$t("why_choose_hk.card_two_subheading"),
                },
                {
                    imgSrc: img3,
                    alt:"Flexible and Scalable | HotelKey",
                    title: this.$t("why_choose_hk.card_three_heading"),
                    outsideText:this.$t("why_choose_hk.card_three_subheading"),
                },
                {
                    imgSrc: img4,
                    alt:"24/7 Global Support | HotelKey",
                    title: "24/7 Global Support",
                    outsideText:this.$t("why_choose_hk.card_four_subheading"),
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.card {
    margin-bottom: 20px;
    border: 0;
}

.image-container {
    position: relative;
}

.card-img-top {
    width: 100%;
    height: auto;
    /* Ensure images maintain their aspect ratio */
}

.card-title {

    bottom: 10px;
    /* Adjust as needed */
    left: 10px;
    /* Adjust as needed */
    color: rgb(0, 0, 0);
    /* Change text color as necessary */
    padding: 5px 0px;
    font-weight: 600;
}

.card-body {
    flex: 1 1 auto;
    padding: 10px 0px;
    color: var(--bs-card-color);
}

.outside-text-container {

    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    /* align-content: space-between; */
    flex-direction: column;
}

.hk-banner-text {
    color: #000;
}
</style>
